import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple, DemoContent, TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import Formsy from 'formsy-react';
import { Button, FormControlLabel, TextField, Hidden, MenuItem, Radio, Icon, Checkbox, Typography, IconButton, Select,AppBar,Toolbar } from 'material-ui';
import ReactTable from "react-table";
import axios from 'axios';
import { bindActionCreators } from 'redux';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';

import Scrollbar from "perfect-scrollbar-react";
import classNames from "classnames";
import "perfect-scrollbar-react/dist/style.min.css";
import "react-table/react-table.css";

import Loader from "other-components/loader/loader";
import Tooltip from 'material-ui/Tooltip';
import { withAlert } from 'react-alert';
import { confirmAlert } from 'react-confirm-alert'; // Import
import printjs from 'print-js';
import CloseIcon from '@material-ui/icons/Close';
import moment from 'moment';

const CustomTbodyComponent = props => (
    <div {...props} className={classNames("rt-tbody", props.className || [])}>
        <Scrollbar>{props.children}</Scrollbar>
    </div>
);


const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64
    },
    tabRoot: {
        height: 64
    },
    smaller: {
        width: 30,
        height: 20,
    }
});

var selecterCustomerType = 0;
var selecterCustomerTypeName = 0;
var startDate = moment(new Date()).format("YYYY-MM-DD");
var endDate = moment(new Date()).format("YYYY-MM-DD");
var endDate = moment(new Date()).format("YYYY-MM-DD");
var selectCheackBox = 0;
var name = "No Data";
var contactPersonPassport= "No Data";
var  contactPersonAddress= "No Data";
var  contactPersonCountry= "No Data";
var   contactPersonState= "No Data";
var   contactPersonCity= "No Data";
var   contactPersonZipcode= "No Data";
var  contactPersonMobile= "No Data";
var  contactPersonHomeTel= "No Data";
var  contactPersonEmail= "No Data";
var  contactPersonOfficeTel= "No Data";

var  customerName= "No Data";
var  customerCompany= "No Data";
var  customerTax= "No Data";
var  customerPostAddress= "No Data";
var  customerPostCountry= "No Data";
var  customerBillAddress= "No Data";
var  customerBillCountry= "No Data";
var  customerCreditLimit= "No Data";
var  customerCreditPeriod= "No Data";
var  customerType= "No Data";


class CustomerList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            open: false,
            selecterCustomerType: 0,
            selecterCustomerTypeName: 0,
            startDate: moment(new Date()).format("YYYY-MM-DD"),
            endDate:moment(new Date()).format("YYYY-MM-DD"),
            selectCheackBox: 0,
            tableData: [],
            customerType: []
        };
        this.handleChangeCustomerType = this.handleChangeCustomerType.bind(this);
        this.handleChangeStartDate = this.handleChangeStartDate.bind(this);
        this.handleChangeEndDate = this.handleChangeEndDate.bind(this);
        this.handleChangecheackBox = this.handleChangecheackBox.bind(this);

    }

    state = {
        value: 0,
        contactDetail:false,
        customerDetail:false,

    };

    handleChangeCustomerType(event) {
        // alert(event.target.value)
        selecterCustomerType = event.target.value;
        this.setState({ selecterCustomerType: event.target.value });

    }

    handleChangeStartDate(event) {
        //alert(event.target.value)
        startDate = event.target.value;
        this.setState({ startDate: event.target.value });

    }

    handleChangeEndDate(event) {
        //alert(event.target.value)
        endDate = event.target.value;
        this.setState({ endDate: event.target.value });

    }

    handleChangecheackBox = name => event => {

        this.setState({ [name]: event.target.checked });
        selectCheackBox = event.target.checked;
    };

    handleClickView = () => {


        var ctype = selecterCustomerType;
        var cstartdate = startDate;
        var cenddate = endDate;
        var all = selectCheackBox;

        // alert(ctype + "" + cstartdate + "" + cenddate + "" + all)

        if (ctype != 0 || all == 1) {
            if (cstartdate != 0) {
                if (cenddate != 0) {

                    if (all == 1) {
                        this.setState({ loading: true });
                        var tableData = [];
                        axios.get(window.crmServer+'/crm/getCustomer/all', {
                            params: {
                                
                                    startDate:cstartdate,
                                    endDate:cenddate
                                    
                            }
                        })
                            .then(response => {
                                console.log(response.data);

                                var c;
                                for (c = 0; c < response.data.length; c++) {



                                    tableData.push({

                                        date: (response.data[c].CREATED_DATE).substring(0, 10),
                                        customerType: response.data[c].CUSTOMER_PROFILE.cx_type,
                                        customerCode: response.data[c].CUSTOMER_CODE_PREFIX + " " + response.data[c].CUSTOMER_CODE + " " + response.data[c].CUSTOMER_CODE_SUFFIX,
                                        customerName: response.data[c].CUSTOMER_PROFILE.cx_title + ". " + response.data[c].CUSTOMER_PROFILE.cx_name,
                                        contactPerson: response.data[c].CONTACT_PERSONS[0].name,
                                        contactPersonPassport: response.data[c].CONTACT_PERSONS[0].nic_ssn_passport,
                                        contactPersonAddress: response.data[c].CONTACT_PERSONS[0].address,
                                        contactPersonCountry: response.data[c].CONTACT_PERSONS[0].address_country,
                                        contactPersonState: response.data[c].CONTACT_PERSONS[0].address_state,
                                        contactPersonCity: response.data[c].CONTACT_PERSONS[0].address_city,
                                        contactPersonZipcode: response.data[c].CONTACT_PERSONS[0].address_zipcode,
                                        contactPersonMobile: response.data[c].CONTACT_PERSONS[0].phone_mobile,
                                        contactPersonHomeTel: response.data[c].CONTACT_PERSONS[0].phone_home,
                                        contactPersonEmail: response.data[c].CONTACT_PERSONS[0].email,
                                        contactPersonOfficeTel: response.data[c].CONTACT_PERSONS[0].phone_office,
                                        lastVisitDate: response.data[c].CONTACT_PERSONS.phone_office,
                                        //lastVisitDate: response.data[c].CONTACT_PERSONS.phone_office,
                                        customerTitale: response.data[c].CUSTOMER_PROFILE.cx_title,
                                       // customer: response.data[c].CUSTOMER_PROFILE.cx_name,
                                       customerCompany: response.data[c].CUSTOMER_PROFILE.cx_company,
                                       customerTax: response.data[c].CUSTOMER_PROFILE.cx_tax,
                                       customerPostAddress: response.data[c].CUSTOMER_PROFILE.cx_postal_address,
                                       customerPostCountry: response.data[c].CUSTOMER_PROFILE.cx_postal_address_country,
                                       customerBillAddress: response.data[c].CUSTOMER_PROFILE.cx_billing_address,
                                       customerBillCountry: response.data[c].CUSTOMER_PROFILE.cx_billing_address_country,
                                       customerCreditLimit: response.data[c].CUSTOMER_PROFILE.cx_credit_limit,
                                       customerCreditPeriod: response.data[c].CUSTOMER_PROFILE.cx_credit_period,

                                    });


                                }

                                console.log(tableData);

                                this.setState({ loading: false });
                                this.setState({ tableData: tableData });

                            }
                            );
                    }else{
                        //alert(selecterCustomerType)
                        this.setState({ loading: true });
                        var tableData = [];
                        axios.post(window.crmServer+'/crm/getCustomer/byType', {
                          
                                    type:selecterCustomerType,
                                    startDate:cstartdate,
                                    endDate:cenddate
                                    
                            
                        })
                            .then(response => {
                                console.log(response.data);

                                var c;
                                for (c = 0; c < response.data.length; c++) {



                                    tableData.push({

                                        date: (response.data[c].CREATED_DATE).substring(0, 10),
                                        customerType: response.data[c].CUSTOMER_PROFILE.cx_type,
                                        customerCode: response.data[c].CUSTOMER_CODE_PREFIX + " " + response.data[c].CUSTOMER_CODE + " " + response.data[c].CUSTOMER_CODE_SUFFIX,
                                        customerName: response.data[c].CUSTOMER_PROFILE.cx_title + ". " + response.data[c].CUSTOMER_PROFILE.cx_name,
                                        contactPerson: response.data[c].CONTACT_PERSONS[0].name,
                                        contactPersonPassport: response.data[c].CONTACT_PERSONS[0].nic_ssn_passport,
                                        contactPersonAddress: response.data[c].CONTACT_PERSONS[0].address,
                                        contactPersonCountry: response.data[c].CONTACT_PERSONS[0].address_country,
                                        contactPersonState: response.data[c].CONTACT_PERSONS[0].address_state,
                                        contactPersonCity: response.data[c].CONTACT_PERSONS[0].address_city,
                                        contactPersonZipcode: response.data[c].CONTACT_PERSONS[0].address_zipcode,
                                        contactPersonMobile: response.data[c].CONTACT_PERSONS[0].phone_mobile,
                                        contactPersonHomeTel: response.data[c].CONTACT_PERSONS[0].phone_home,
                                        contactPersonEmail: response.data[c].CONTACT_PERSONS[0].email,
                                        contactPersonOfficeTel: response.data[c].CONTACT_PERSONS[0].phone_office,
                                        lastVisitDate: response.data[c].CONTACT_PERSONS.phone_office,
                                        //lastVisitDate: response.data[c].CONTACT_PERSONS.phone_office,
                                        customerTitale: response.data[c].CUSTOMER_PROFILE.cx_title,
                                       // customer: response.data[c].CUSTOMER_PROFILE.cx_name,
                                       customerCompany: response.data[c].CUSTOMER_PROFILE.cx_company,
                                       customerTax: response.data[c].CUSTOMER_PROFILE.cx_tax,
                                       customerPostAddress: response.data[c].CUSTOMER_PROFILE.cx_postal_address,
                                       customerPostCountry: response.data[c].CUSTOMER_PROFILE.cx_postal_address_country,
                                       customerBillAddress: response.data[c].CUSTOMER_PROFILE.cx_billing_address,
                                       customerBillCountry: response.data[c].CUSTOMER_PROFILE.cx_billing_address_country,
                                       customerCreditLimit: response.data[c].CUSTOMER_PROFILE.cx_credit_limit,
                                       customerCreditPeriod: response.data[c].CUSTOMER_PROFILE.cx_credit_period,

                                    });


                                }

                                console.log(tableData);

                                this.setState({ loading: false });
                                this.setState({ tableData: tableData });

                            }
                            );
                    }

                } else {
                    this.props.alert.error("Select End Date");
                }
            } else {
                this.props.alert.error("Select Start Date.");
            }
        } else {
            this.props.alert.error("Select Customer Type");
        }
    };

    handleClickPrint = () => {

        
        var ctype = selecterCustomerType;
        var cstartdate = startDate;
        var cenddate = endDate;
        var all = selectCheackBox;

        if (ctype != 0 || all == 1) {
            if (cstartdate != 0) {
                if (cenddate != 0) {

                    if (all == 1) {
                        var address = null;
                        axios.get(window.reportServer+'/report/get/customerListAll', {
                            params: {
                                startDate: cstartdate,
                                endDate: cenddate
                            }
                        })
                            .then(response => {
            
                                address = response.data.path;
                                address = window.reportServer+"/" + address;
                                
                                //alert(address)
                                printjs({ printable: address, type: 'pdf', showModal: true })
            
                            }
                            );
                        }else{
                            var address = null;
                        axios.get(window.reportServer+'/report/get/customerListType', {
                            params: {
                                type:selecterCustomerType,
                                startDate: cstartdate,
                                endDate: cenddate
                            }
                        })
                            .then(response => {
            
                                address = response.data.path;
                                address = window.reportServer+"/" + address;
                                
                                //alert(address)
                                printjs({ printable: address, type: 'pdf', showModal: true })
            
                            }
                            );
                        }
            
                    } else {
                        this.props.alert.error("Select End Date");
                    }
                } else {
                    this.props.alert.error("Select Start Date.");
                }
            } else {
                this.props.alert.error("Select Customer Type");
            }
        

        };

        handleClickTableContactPersonClose = (rowInfo) => {
            this.setState({ contactDetail: false })
        }

        handleClickTableCustomerDetailClose = () => {
            this.setState({ customerDetail: false })
        }

        

        render() {
            if (this.state.loading) {
                return (
                    <Loader />
                );
            } else {
                const { openEditContactDialog } = this.props;
                const { canSubmit } = this.state;
                const { classes } = this.props;
                return (
                    <FusePageSimple
                        classes={{
                            root: classes.layoutRoot,
                            toolbar: classes.layoutToolbar
                        }}

                        contentToolbar={
                            <div className="flex flex-1 flex-col sm:flex-row items-center justify-between p-24">

                                <div className="flex flex-1 items-center">

                                    <div className="subtitle-color flex items-center">
                                        <Icon className="text-32 mr-12">account_box</Icon>
                                        <Typography class="sutitle-color" variant="title">Customer List</Typography>
                                    </div>


                                </div>


                            </ div>


                        }
                        content={

                            <div class="flex h-auto ">

                                <div class="w-full bg-white h-auto m-4">

                                    <div class="border-1 w-full p-4 ">


                                        <div className="sm:p-16 border-0 inline-block sm:w-1/3"  >
                                            <h3 className="h2 pb-8">Select Customer</h3>

                                            Customer Type :
                                        <Select
                                                className="pl-16"
                                                name="selecterCustomerType"
                                                label="Customer Type"
                                                //value="none"
                                                value={this.state.selecterCustomerType}
                                                onChange={this.handleChangeCustomerType}
                                            >
                                                <MenuItem className="popup-value-size" value={0}>
                                                    <em>Please Select</em>
                                                </MenuItem>
                                                {this.state.customerType.map(function (item, i) {
                                                    return <MenuItem className="popup-value-size" value={item.customerTypeName}>{item.customerTypeName}</MenuItem>;
                                                })}

                                            </Select>



                                            <Checkbox
                                                checked={this.state.selectCheackBox}
                                                onChange={this.handleChangecheackBox('selectCheackBox')}

                                            />
                                            All
                                    </div>


                                        <div className=" border-0 inline-block sm:w-2/3" >
                                            <h3 className="h2 pb-4">Net Calebration</h3>

                                            <div className=" border-0 inline-block sm:w-1/2" >

                                                From Date :
    
                                            <TextField
                                                    className="pl-16 mx-10"
                                                    type="date"
                                                    name="unitNo"
                                                    //label="No of Unit"
                                                    value={this.state.startDate}
                                                    onChange={this.handleChangeStartDate}
                                                    validations={{
                                                        minLength: 1
                                                    }}
                                                    validationErrors={{
                                                        minLength: 'Min character length is 4'
                                                    }}
                                                    required
                                                //disabled={true}
                                                />

                                            </div>



                                            <div className="border-0 inline-block sm:w-1/2" >

                                                To Date
    
                                            <TextField
                                                    className="pl-16 mx-10"
                                                    type="date"
                                                    name="unitNo"
                                                    //label="No of Unit"
                                                    value={this.state.endDate}
                                                    onChange={this.handleChangeEndDate}
                                                    validations={{
                                                        minLength: 1
                                                    }}
                                                    validationErrors={{
                                                        minLength: 'Min character length is 4'
                                                    }}
                                                    required
                                                //disabled={true}
                                                />

                                            </div>
                                        </div>

                                        <div className="sm:pb-8 w-full">
                                            <div className="border-0 sm:inline-block sm:w-3/4" >
                                            </div>
                                            <div className="border-0 sm:inline-block sm:w-1/4" >
                                                <Tooltip
                                                    enterDelay={300}
                                                    id="tooltip-controlled"
                                                    leaveDelay={300}
                                                    placement="bottom"
                                                    title="Do you want to View ?"
                                                >
                                                    <Button
                                                        onClick={this.handleClickView}
                                                        type="submit"
                                                        variant="raised"
                                                        color="secondary"
                                                        className="w-full md:w-1/3 md:h-24 mt-16 mr-8"
                                                        aria-label="Help"
                                                    //disabled={!canSubmit}
                                                    >
                                                        View
                                </Button>
                                                </Tooltip>

                                                <Tooltip
                                                    enterDelay={300}
                                                    id="tooltip-controlled"
                                                    leaveDelay={300}
                                                    placement="bottom"
                                                    title="Do you want to Print ?"
                                                >
                                                    <Button
                                                        onClick={this.handleClickPrint}
                                                        type="submit"
                                                        variant="raised"
                                                        color="secondary"
                                                        className="w-full md:w-1/3 md:h-24 mt-16 mr-8"
                                                        aria-label="Help"
                                                    //disabled={!canSubmit}
                                                    >
                                                        Print
                                </Button>
                                                </Tooltip>
                                            </div>
                                        </div>

                                    </div>

                                   {/* //////////////////////////////////////**************** */}
                                   {/* ////Contact Person */}
                                   <Dialog className={classNames(classes.root, "z-10")}   open={this.state.contactDetail} fullWidth maxWidth="md" className="w-full">
                                                              <AppBar className="flex w-full h-56 app-bar-size" position="static">
                                                            <Toolbar className="flex w-full">
                                                                <Typography className="w-full" variant="subheading" color="inherit">
                                                                    View Contact Person More Detail
                          </Typography>
                                                                <IconButton className="" color="inherit" onClick={this.handleClickTableContactPersonClose} aria-label="Close">
                                                                    <CloseIcon />
                                                                </IconButton>
                                                            </Toolbar>
                                                        </AppBar>
          
        
           
            <DialogContent>

                <div  className="mt-20 w-full">

                <div  className="mt-20 w-full">
                <div  className="sm:mt-20 sm:inline-block sm:w-1/2">
                <label ><h2>Contact Person Name : </h2></label>
<label >{name}</label>
                </div> 
                <div  className="sm:mt-20 sm:inline-block sm:w-1/2">
                <label ><h2>Contact Person Address : </h2></label>
<label >{contactPersonAddress}</label>

                </div> 
                </div> 

                <div  className="mt-20 w-full">
                <div  className="sm:mt-20 sm:inline-block sm:w-1/2">
                <label ><h2>Contact Person Country : </h2></label>
<label >{contactPersonCountry}</label>
                </div> 
                <div  className="sm:mt-20 sm:inline-block sm:w-1/2">
                <label ><h2>Contact Person State : </h2></label>
<label >{contactPersonState}</label>

                </div> 
                </div> 

                
                <div  className="mt-20 w-full">
                <div  className="sm:mt-20 sm:inline-block sm:w-1/2">
                <label ><h2>Contact Person City : </h2></label>
<label >{contactPersonCity}</label>
                </div> 
                <div  className="sm:mt-20 sm:inline-block sm:w-1/2">
                <label ><h2>Contact Person Zip Code : </h2></label>
<label >{contactPersonZipcode}</label>

                </div> 
                </div> 

                   <div  className="mt-20 w-full">
                <div  className="sm:mt-20 sm:inline-block sm:w-1/2">
                <label ><h2>Contact Person Mobile : </h2></label>
<label >{contactPersonMobile}</label>
                </div> 
                <div  className="sm:mt-20 sm:inline-block sm:w-1/2">
                <label ><h2>Contact Person Home : </h2></label>
<label >{contactPersonHomeTel}</label>

                </div> 
                </div> 

                 <div  className="mt-20 w-full">
                <div  className="sm:mt-20 sm:inline-block sm:w-1/2">
                <label ><h2>Contact Person Office : </h2></label>
<label >{contactPersonOfficeTel}</label>
                </div> 
                <div  className="sm:mt-20 sm:inline-block sm:w-1/2">
                <label ><h2>Contact Person E-mail : </h2></label>
<label >{contactPersonEmail}</label>

                </div> 
              

                </div>


                </div>
            </DialogContent>


        </Dialog>
        
                                   {/* //////////////////////////////////////**************** */}

                                      {/* //////////////////////////////////////**************** */}
                                   {/* ////Customer Detail */}
                                   <Dialog className={classNames(classes.root, "z-10")}   open={this.state.customerDetail} fullWidth maxWidth="md" className="w-full">
                                                              <AppBar className="flex w-full h-56 app-bar-size" position="static">
                                                            <Toolbar className="flex w-full">
                                                                <Typography className="w-full" variant="subheading" color="inherit">
                                                                    View Customer More Detail
                          </Typography>
                                                                <IconButton className="" color="inherit" onClick={this.handleClickTableCustomerDetailClose} aria-label="Close">
                                                                    <CloseIcon />
                                                                </IconButton>
                                                            </Toolbar>
                                                        </AppBar>
          
        
           
            <DialogContent>

                <div  className="mt-20 w-full">

                <div  className="mt-20 w-full">
                <div  className="sm:mt-20 sm:inline-block sm:w-1/2">
                <label ><h2>Customer Name : </h2></label>
<label >{customerName}</label>
                </div> 
                <div  className="sm:mt-20 sm:inline-block sm:w-1/2">
                <label ><h2>Customer Company : </h2></label>
<label >{customerCompany}</label>

                </div> 
                </div> 

                <div  className="mt-20 w-full">
                <div  className="sm:mt-20 sm:inline-block sm:w-1/2">
                <label ><h2>Customer Tax No : </h2></label>
<label >{customerTax}</label>
                </div> 
                <div  className="sm:mt-20 sm:inline-block sm:w-1/2">
                <label ><h2>Post Address : </h2></label>
<label >{customerPostAddress}</label>

                </div> 
                </div> 

                
                <div  className="mt-20 w-full">
                <div  className="sm:mt-20 sm:inline-block sm:w-1/2">
                <label ><h2>Post Country : </h2></label>
<label >{customerPostCountry}</label>
                </div> 
                <div  className="sm:mt-20 sm:inline-block sm:w-1/2">
                <label ><h2>Bill Address : </h2></label>
<label >{customerBillAddress}</label>

                </div> 
                </div> 

                   <div  className="mt-20 w-full">
                <div  className="sm:mt-20 sm:inline-block sm:w-1/2">
                <label ><h2>Bill Country : </h2></label>
<label >{customerBillCountry}</label>
                </div> 
                <div  className="sm:mt-20 sm:inline-block sm:w-1/2">
                <label ><h2>Credit Limit : </h2></label>
<label >{customerCreditLimit}</label>

                </div> 
                </div> 

                 <div  className="mt-20 w-full">
                <div  className="sm:mt-20 sm:inline-block sm:w-1/2">
                <label ><h2>Credit Period : </h2></label>
<label >{customerCreditPeriod}</label>
                </div> 
                <div  className="sm:mt-20 sm:inline-block sm:w-1/2">
                <label ><h2>Type : </h2></label>
<label >{customerType}</label>

                </div> 
              

                </div>


                </div>
            </DialogContent>


        </Dialog>
        
                                   {/* //////////////////////////////////////**************** */}

                                    <div class="border-0 m-4">
                                        <ReactTable


                                            getTrProps={(state, rowInfo, column) => {
                                                return {
                                                    className: "cursor-pointer",
                                                    // onClick: (e, handleOriginal) => {
                                                       
                                                    
                                                    //         this.handleClickTable(rowInfo.original,column.field);
                                                        
                                                    // }
                                                    
                                                }
                                            }}
                                            TbodyComponent={CustomTbodyComponent}
                                            data={this.state.tableData}

                                            columns={[

                                                {
                                                    Header: "Date",
                                                    accessor: "date",


                                                },
                                                {
                                                    Header: "Customer Type",
                                                    accessor: "customerType",

                                                }
                                                ,
                                                {
                                                    Header: "Customer Code",
                                                    accessor: "customerCode",

                                                }
                                                ,
                                                {
                                                    Header: "Customer Name",
                                                    accessor: "customerName",
                                                    Cell: row => (
                                                        <span style={{color: 'blue'}} onClick={(e) => {
                                                            if (row) {
        
                                               
                                                                // this.handleClickTableContactPerson();
                                                                customerName = row.original.customerName;
                                                                customerCompany = row.original.customerCompany;
                                                                customerTax = row.original.customerTax;
                                                                customerPostAddress = row.original.customerPostAddress;
                                                                customerPostCountry = row.original.customerPostCountry;
                                                                customerBillAddress = row.original.customerBillAddress;
                                                                customerBillCountry = row.original.customerBillCountry;
                                                                customerCreditLimit = row.original.customerCreditLimit;
                                                                customerCreditPeriod = row.original.customerCreditPeriod;
                                                                customerType = row.original.customerType;
                                                              
                                                                this.setState({ customerDetail: true });
 
                                                             }
                                                        }
                                                        
                                                        }>
                                                         {
                                                           row.value
                                                        }
                                                        
                                                        </span> )
                                                            

                                                }
                                                ,
                                                {
                                                    Header: "Contact Person",
                                                    accessor: "contactPerson",
                                                    Cell: row => (
                                                        <span style={{color: 'blue'}} onClick={(e) => {
                                                            if (row) {
        
                                               
                                                                // this.handleClickTableContactPerson();
                                                                name = row.original.contactPerson;
                                                                contactPersonPassport = row.original.contactPersonPassport;
                                                                contactPersonAddress = row.original.contactPersonAddress;
                                                                contactPersonCountry = row.original.contactPersonCountry;
                                                                contactPersonState = row.original.contactPersonState;
                                                                contactPersonCity = row.original.contactPersonCity;
                                                                contactPersonZipcode = row.original.contactPersonZipcode;
                                                                contactPersonMobile = row.original.contactPersonMobile;
                                                                contactPersonHomeTel = row.original.contactPersonHomeTel;
                                                                contactPersonEmail = row.original.contactPersonEmail;
                                                                contactPersonOfficeTel = row.original.contactPersonOfficeTel;

                                                                this.setState({ contactDetail: true });
 
                                                             }
                                                        }} > {
                                                            row.value
                                                        }
                                                                                                    
                                                        
                                                            </span>
                                                            )

                                                }
                                                ,

                                                {
                                                    Header: "E-mail",
                                                    accessor: "contactPersonEmail",

                                                }
                                                // ,
                                                // {
                                                //     Header: "Last Visit Date",
                                                //     accessor: "lastVisitDate",

                                                // }

                                            ]}
                                            defaultPageSize={10}
                                            style={{
                                                height: "450px" // This will force the table body to overflow and scroll, since there is not enough room
                                            }}
                                            className="-striped -highlight"
                                        />
                                    </div>
                                </div>



                            </div>
                        }
                    />
                )

                
            }
          
        }

        componentWillMount() {
            var customerType = [];
            // get customer type
            axios.get(window.systemServer+'/system/loadCustomerTypes')
                .then(response => {
                    //  console.log(response.data.length);

                    var c;
                    for (c = 0; c < response.data.length-1; c++) {
                        customerType.push({
                            customerTypeId: JSON.stringify(response.data[c]._id),
                            customerTypeName: response.data[c].customer_type,
                        });


                    }

                    this.setState({ customerType: customerType });

                }
                );
            this.setState({ loading: false });
        }

    }

    export default withStyles(styles, { withTheme: true })(withAlert(CustomerList));










// WEBPACK FOOTER //
// ./src/main/content/report/customerList/CustomerList.js